import Burger from './assets/glow/burger.svg';
import Decline from './assets/glow/decline.svg';
import Globe from './assets/glow/globe.svg';
import Comment from './assets/glow/comment.svg';
import Avatar from './assets/glow/avatar.svg';
import Search from './assets/glow/search.svg';
import NotificationBell from './assets/glow/notification-bell.svg';
import ShoppingCart from './assets/glow/shopping-cart.svg';
import NavigationArrowLeft from './assets/glow/navigation-arrow-left.svg';
import NavigationArrowRight from './assets/glow/navigation-arrow-right.svg';
import Information from './assets/glow/information.svg';
import Warning from './assets/glow/warning.svg';
import Error from './assets/glow/error.svg';
import StatusPositive from './assets/glow/status-positive.svg';
import ExternalLink from './assets/glow/external-link.svg';

export const IconsGlow = {
  Globe,
  Burger,
  Decline,
  Avatar,
  Comment,
  Search,
  NotificationBell,
  ShoppingCart,
  NavigationArrowLeft,
  NavigationArrowRight,
  Information,
  Warning,
  Error,
  StatusPositive,
  ExternalLink
};
